<template>
  <header class="grid md:flex items-center bg-white border-gray-200" role="banner" aria-label="Site">
    <div
      class="w-full grid grid-cols-3 md:flex md:flex-row md:justify-between items-center px-8 mx-auto gap-4 py-4 h-14"
    >
      <MenuButton v-if="isLoggedIn" />
      <div class="flex items-center justify-center gap-4 order-1 min-w-0">
        <img :src="logo" data-cy="logoApiAbroad" class="h-8 shrink-0 object-contain logo" alt="API" />
        <ImpersonationBanner v-if="isLoggedIn" />
      </div>

      <UniversityChangeDesktop v-if="!studentDataAvailable && retiredMyStudentsIsActive" />
      <div class="flex items-top order-3 md:order-last justify-end w-full md:w-auto md:flex-1 md:min-w-0">
        <NavBar v-if="isLoggedIn" />
        <InboundOutbound v-if="isLoggedIn && hasInboundOrOutboundPermissions" class="hidden md:flex mr-10 order-2" />
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import InboundOutbound from "@/components/Header/InboundOutbound.vue";
import NavBar from "@/components/Header/NavBar.vue";
import UniversityChangeDesktop from "@/components/Header/universityChangeDesktop.vue";
import { hasAnyPermission } from "@/components/Header/utils.js";
import ImpersonationBanner from "@/components/Impersonation/ImpersonationBanner.vue";
import MenuButton from "@/components/shared/MenuButton.vue";
import { FEATURES, INBOUND_PERMISSIONS, OUTBOUND_PERMISSIONS } from "@/constants";

import { DEFAULT_LOGO_URL } from "@/util/branding";
export default {
  components: {
    NavBar,
    MenuButton,
    ImpersonationBanner,
    InboundOutbound,
    UniversityChangeDesktop,
  },
  props: {
    logo: {
      type: String,
      default: DEFAULT_LOGO_URL,
    },
    ldClient: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapState(["userData", "featureFlags"]),
    ...mapGetters(["isLoggedIn", "getCurrentUser"]),

    studentDataAvailable() {
      return this.userData !== null && Object.entries(this.userData).length > 0;
    },

    retiredMyStudentsIsActive() {
      return this.featureFlags[FEATURES.myStudentsRetired];
    },

    hasInboundOrOutboundPermissions() {
      return hasAnyPermission(this.getCurrentUser?.permissions, [...INBOUND_PERMISSIONS, ...OUTBOUND_PERMISSIONS]);
    },

    testMode() {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get("test-mode") === "true";
    },
  },
  created() {
    //set feature flags to store
    if (this.ldClient && !this.testMode) {
      const ldClient = JSON.parse(this.ldClient);
      const featureFlags = Object.keys(ldClient)
        .filter((key) => !key.includes("$"))
        .reduce((cur, key) => {
          return Object.assign(cur, { [key]: ldClient[key] });
        }, {});
      this.$store.commit("setFeatureFlags", featureFlags);
    }
  },
};
</script>
